// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23FF69B4%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Background Colors */
  --bg-primary: #FFF5F7; /* Very light blush - app background */
  --bg-secondary: #FFE8ED; /* Light baby pink - cards/surfaces */
  --bg-tertiary: #FFD6E0; /* Slightly deeper - section containers */
  
  /* Text Colors */
  --text-primary: #1A0A0E; /* Near-black for readability on light backgrounds */
  --text-secondary: #5A3A45; /* Dark gray-pink for secondary text */
  --text-tertiary: #8A6A75; /* Muted pink-gray for tertiary text */
  
  /* Accent Colors */
  --accent: #FF69B4; /* Vibrant pink - primary CTAs */
  --accent-hover: #FF4DA6; /* Darker pink for hover */
  --accent-light: #FF8CC8; /* Lighter pink variant */
  
  /* Border Colors */
  --border: #FFD0D9; /* Subtle pink-gray borders */
  --border-light: #FFE0E6; /* Lighter borders */
  
  /* Status Colors */
  --success: #4caf50; /* Success states (kept green for readability) */
  --error: #E91E63; /* Pink-red for errors (harmonized) */
  --warning: #FF6B9D; /* Pink-orange for warnings */
  
  /* Nutrition Colors */
  --protein: #FF69B4; /* Primary pink for protein */
  --carbs: #FF8CC8; /* Light pink for carbs */
  --fat: #FF6B9D; /* Pink-red for fat */
  --calories: #FFB347; /* Warm orange-pink for calories */
  
  /* Typography Scale */
  --font-size-xs: 12px;
  --font-size-sm: 14px;
  --font-size-base: 16px;
  --font-size-lg: 18px;
  --font-size-xl: 20px;
  --font-size-2xl: 24px;
  --font-size-3xl: 28px;
  --font-size-4xl: 32px;
  
  /* Font Weights */
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  
  /* Line Heights */
  --line-height-tight: 1.2;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.75;
  
  /* Spacing Scale */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;
  
  /* Border Radius */
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 20px;
  --radius-full: 9999px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.15);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.2);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.25);
  --shadow-glow: 0 0 20px rgba(255, 105, 180, 0.3);
  
  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-base: 200ms ease;
  --transition-slow: 300ms ease;
  --transition-bounce: 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  
  /* Gradients */
  --gradient-primary: linear-gradient(135deg, #FF69B4 0%, #FF8CC8 100%);
  --gradient-success: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  --gradient-card: linear-gradient(135deg, #FFE8ED 0%, #FFD6E0 100%);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  margin: 0;
  padding: 0;
  min-height: 100vh;
  overflow-x: hidden;
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-primary);
}

::-webkit-scrollbar-thumb {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--border);
}

/* Button styles */
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all var(--transition-base);
  font-weight: var(--font-weight-semibold);
  -webkit-tap-highlight-color: transparent;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

button:active {
  transform: scale(0.98);
}

/* Input styles */
input, select, textarea {
  font-family: inherit;
  color: var(--text-primary);
  background-color: var(--bg-secondary);
  border: 1px solid var(--border);
  outline: none;
  transition: all var(--transition-base);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input::placeholder {
  color: var(--text-tertiary);
  opacity: 0.6;
}

input:focus, select:focus, textarea:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(255, 105, 180, 0.15);
  transform: scale(1.01);
  transition: all var(--transition-base);
}

input:focus::placeholder, textarea:focus::placeholder {
  opacity: 0.4;
  transition: opacity var(--transition-base);
}

input:invalid {
  border-color: var(--error);
}

select {
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

/* Responsive design */
@media (max-width: 768px) {
  body {
    font-size: 14px;
  }
  
  /* Ensure touch targets are at least 44px */
  button, a, input, select {
    min-height: 44px;
    min-width: 44px;
  }
  
  /* Better spacing on mobile */
  .card-hover {
    margin-bottom: 12px;
  }
}

@media (min-width: 769px) {
  body {
    font-size: 16px;
  }
  
  /* Tablet and desktop optimizations */
  .card-hover:hover {
    transform: translateY(-3px);
  }
}

@media (min-width: 1024px) {
  /* Desktop specific styles */
  #root {
    max-width: 1200px;
    margin: 0 auto;
  }
}

/* Safe area for mobile devices */
@supports (padding: max(0px)) {
  body {
    padding-left: max(0px, env(safe-area-inset-left));
    padding-right: max(0px, env(safe-area-inset-right));
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideOutToBottom {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* Utility Classes */
.fade-in {
  animation: fadeIn var(--transition-slow) ease;
}

.slide-in {
  animation: slideIn var(--transition-slow) ease;
}

.slide-in-up {
  animation: slideInUp var(--transition-slow) ease;
}

.scale-in {
  animation: scaleIn var(--transition-base) ease;
}

/* List item stagger animation */
.list-item {
  animation: slideIn 0.3s ease forwards;
  opacity: 0;
}

.list-item:nth-child(1) { animation-delay: 0.05s; }
.list-item:nth-child(2) { animation-delay: 0.1s; }
.list-item:nth-child(3) { animation-delay: 0.15s; }
.list-item:nth-child(4) { animation-delay: 0.2s; }
.list-item:nth-child(5) { animation-delay: 0.25s; }
.list-item:nth-child(6) { animation-delay: 0.3s; }
.list-item:nth-child(7) { animation-delay: 0.35s; }
.list-item:nth-child(8) { animation-delay: 0.4s; }

/* Loading Spinner */
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--bg-tertiary);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spinner 0.8s linear infinite;
  margin: 0 auto;
}

.spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid var(--bg-tertiary);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spinner 0.6s linear infinite;
}

/* Skeleton Loading */
.skeleton {
  background: linear-gradient(
    90deg,
    var(--bg-secondary) 0%,
    var(--bg-tertiary) 50%,
    var(--bg-secondary) 100%
  );
  background-size: 1000px 100%;
  animation: shimmer 2s infinite;
  border-radius: 8px;
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Focus visible for accessibility */
*:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

/* Skip to main content link for screen readers */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--accent);
  color: var(--text-primary);
  padding: 8px;
  text-decoration: none;
  z-index: 100;
  border-radius: 0 0 4px 0;
}

.skip-link:focus {
  top: 0;
}

/* Improve contrast for better accessibility */
button:not(:disabled):hover,
a:hover {
  opacity: 0.9;
}

/* Ensure sufficient color contrast */
.error-text {
  color: var(--error);
  font-weight: 500;
}

.success-text {
  color: var(--success);
  font-weight: 500;
}

/* Button hover states */
.btn-primary {
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #FF4DA6 0%, #FF7BC4 100%) !important;
  box-shadow: 0 6px 16px rgba(255, 105, 180, 0.4) !important;
  transform: translateY(-1px);
}

.btn-primary:active {
  transform: translateY(0) scale(0.98);
  box-shadow: 0 2px 8px rgba(255, 105, 180, 0.3) !important;
}

.btn-primary:active::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  animation: ripple 0.6s ease-out;
}

.btn-secondary {
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
}

.btn-secondary:hover {
  background-color: var(--bg-tertiary) !important;
  border-color: var(--accent) !important;
  transform: translateY(-1px);
}

.btn-secondary:active {
  transform: translateY(0) scale(0.98);
}

.btn-secondary:active::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 105, 180, 0.2);
  transform: translate(-50%, -50%);
  animation: ripple 0.6s ease-out;
}

/* Card hover effect */
.card-hover {
  transition: all var(--transition-base);
  cursor: pointer;
}

.card-hover:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
  transform: translateY(-2px);
  border-color: rgba(255, 105, 180, 0.3) !important;
}

.card-hover:active {
  transform: translateY(0) scale(0.99);
  transition: transform 100ms ease;
}

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB,EAAE,sCAAsC;EAC7D,uBAAuB,EAAE,qCAAqC;EAC9D,sBAAsB,EAAE,yCAAyC;;EAEjE,gBAAgB;EAChB,uBAAuB,EAAE,oDAAoD;EAC7E,yBAAyB,EAAE,sCAAsC;EACjE,wBAAwB,EAAE,sCAAsC;;EAEhE,kBAAkB;EAClB,iBAAiB,EAAE,gCAAgC;EACnD,uBAAuB,EAAE,0BAA0B;EACnD,uBAAuB,EAAE,yBAAyB;;EAElD,kBAAkB;EAClB,iBAAiB,EAAE,6BAA6B;EAChD,uBAAuB,EAAE,oBAAoB;;EAE7C,kBAAkB;EAClB,kBAAkB,EAAE,gDAAgD;EACpE,gBAAgB,EAAE,qCAAqC;EACvD,kBAAkB,EAAE,6BAA6B;;EAEjD,qBAAqB;EACrB,kBAAkB,EAAE,6BAA6B;EACjD,gBAAgB,EAAE,yBAAyB;EAC3C,cAAc,EAAE,qBAAqB;EACrC,mBAAmB,EAAE,kCAAkC;;EAEvD,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;;EAE3B,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,gDAAgD;;EAEhD,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,iEAAiE;;EAEjE,cAAc;EACd,qEAAqE;EACrE,qEAAqE;EACrE,kEAAkE;AACpE;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sCAAsC;EACtC,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4BAA4B;EAC5B;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,iDAAiD;IACjD,mDAAmD;EACrD;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,oBAAoB;AACpB;EACE,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,qBAAqB,EAAE;;AAEjD,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;EACE;;;;;GAKC;EACD,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;EAChC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,MAAM;AACR;;AAEA,8CAA8C;AAC9C;;EAEE,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC","sourcesContent":[":root {\n  /* Background Colors */\n  --bg-primary: #FFF5F7; /* Very light blush - app background */\n  --bg-secondary: #FFE8ED; /* Light baby pink - cards/surfaces */\n  --bg-tertiary: #FFD6E0; /* Slightly deeper - section containers */\n  \n  /* Text Colors */\n  --text-primary: #1A0A0E; /* Near-black for readability on light backgrounds */\n  --text-secondary: #5A3A45; /* Dark gray-pink for secondary text */\n  --text-tertiary: #8A6A75; /* Muted pink-gray for tertiary text */\n  \n  /* Accent Colors */\n  --accent: #FF69B4; /* Vibrant pink - primary CTAs */\n  --accent-hover: #FF4DA6; /* Darker pink for hover */\n  --accent-light: #FF8CC8; /* Lighter pink variant */\n  \n  /* Border Colors */\n  --border: #FFD0D9; /* Subtle pink-gray borders */\n  --border-light: #FFE0E6; /* Lighter borders */\n  \n  /* Status Colors */\n  --success: #4caf50; /* Success states (kept green for readability) */\n  --error: #E91E63; /* Pink-red for errors (harmonized) */\n  --warning: #FF6B9D; /* Pink-orange for warnings */\n  \n  /* Nutrition Colors */\n  --protein: #FF69B4; /* Primary pink for protein */\n  --carbs: #FF8CC8; /* Light pink for carbs */\n  --fat: #FF6B9D; /* Pink-red for fat */\n  --calories: #FFB347; /* Warm orange-pink for calories */\n  \n  /* Typography Scale */\n  --font-size-xs: 12px;\n  --font-size-sm: 14px;\n  --font-size-base: 16px;\n  --font-size-lg: 18px;\n  --font-size-xl: 20px;\n  --font-size-2xl: 24px;\n  --font-size-3xl: 28px;\n  --font-size-4xl: 32px;\n  \n  /* Font Weights */\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  \n  /* Line Heights */\n  --line-height-tight: 1.2;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.75;\n  \n  /* Spacing Scale */\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n  \n  /* Border Radius */\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 20px;\n  --radius-full: 9999px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.15);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.2);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.25);\n  --shadow-glow: 0 0 20px rgba(255, 105, 180, 0.3);\n  \n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-base: 200ms ease;\n  --transition-slow: 300ms ease;\n  --transition-bounce: 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  \n  /* Gradients */\n  --gradient-primary: linear-gradient(135deg, #FF69B4 0%, #FF8CC8 100%);\n  --gradient-success: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);\n  --gradient-card: linear-gradient(135deg, #FFE8ED 0%, #FFD6E0 100%);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-primary);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--border);\n}\n\n/* Button styles */\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  transition: all var(--transition-base);\n  font-weight: var(--font-weight-semibold);\n  -webkit-tap-highlight-color: transparent;\n}\n\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\nbutton:active {\n  transform: scale(0.98);\n}\n\n/* Input styles */\ninput, select, textarea {\n  font-family: inherit;\n  color: var(--text-primary);\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border);\n  outline: none;\n  transition: all var(--transition-base);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\ninput::placeholder {\n  color: var(--text-tertiary);\n  opacity: 0.6;\n}\n\ninput:focus, select:focus, textarea:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(255, 105, 180, 0.15);\n  transform: scale(1.01);\n  transition: all var(--transition-base);\n}\n\ninput:focus::placeholder, textarea:focus::placeholder {\n  opacity: 0.4;\n  transition: opacity var(--transition-base);\n}\n\ninput:invalid {\n  border-color: var(--error);\n}\n\nselect {\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23FF69B4' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  body {\n    font-size: 14px;\n  }\n  \n  /* Ensure touch targets are at least 44px */\n  button, a, input, select {\n    min-height: 44px;\n    min-width: 44px;\n  }\n  \n  /* Better spacing on mobile */\n  .card-hover {\n    margin-bottom: 12px;\n  }\n}\n\n@media (min-width: 769px) {\n  body {\n    font-size: 16px;\n  }\n  \n  /* Tablet and desktop optimizations */\n  .card-hover:hover {\n    transform: translateY(-3px);\n  }\n}\n\n@media (min-width: 1024px) {\n  /* Desktop specific styles */\n  #root {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n}\n\n/* Safe area for mobile devices */\n@supports (padding: max(0px)) {\n  body {\n    padding-left: max(0px, env(safe-area-inset-left));\n    padding-right: max(0px, env(safe-area-inset-right));\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes slideInFromBottom {\n  from {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideOutToBottom {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n@keyframes ripple {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(4);\n    opacity: 0;\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n}\n\n/* Utility Classes */\n.fade-in {\n  animation: fadeIn var(--transition-slow) ease;\n}\n\n.slide-in {\n  animation: slideIn var(--transition-slow) ease;\n}\n\n.slide-in-up {\n  animation: slideInUp var(--transition-slow) ease;\n}\n\n.scale-in {\n  animation: scaleIn var(--transition-base) ease;\n}\n\n/* List item stagger animation */\n.list-item {\n  animation: slideIn 0.3s ease forwards;\n  opacity: 0;\n}\n\n.list-item:nth-child(1) { animation-delay: 0.05s; }\n.list-item:nth-child(2) { animation-delay: 0.1s; }\n.list-item:nth-child(3) { animation-delay: 0.15s; }\n.list-item:nth-child(4) { animation-delay: 0.2s; }\n.list-item:nth-child(5) { animation-delay: 0.25s; }\n.list-item:nth-child(6) { animation-delay: 0.3s; }\n.list-item:nth-child(7) { animation-delay: 0.35s; }\n.list-item:nth-child(8) { animation-delay: 0.4s; }\n\n/* Loading Spinner */\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--bg-tertiary);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spinner 0.8s linear infinite;\n  margin: 0 auto;\n}\n\n.spinner-small {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--bg-tertiary);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spinner 0.6s linear infinite;\n}\n\n/* Skeleton Loading */\n.skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--bg-secondary) 0%,\n    var(--bg-tertiary) 50%,\n    var(--bg-secondary) 100%\n  );\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: 8px;\n}\n\n/* Smooth scrolling */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Focus visible for accessibility */\n*:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n  border-radius: var(--radius-sm);\n}\n\n/* Skip to main content link for screen readers */\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: var(--accent);\n  color: var(--text-primary);\n  padding: 8px;\n  text-decoration: none;\n  z-index: 100;\n  border-radius: 0 0 4px 0;\n}\n\n.skip-link:focus {\n  top: 0;\n}\n\n/* Improve contrast for better accessibility */\nbutton:not(:disabled):hover,\na:hover {\n  opacity: 0.9;\n}\n\n/* Ensure sufficient color contrast */\n.error-text {\n  color: var(--error);\n  font-weight: 500;\n}\n\n.success-text {\n  color: var(--success);\n  font-weight: 500;\n}\n\n/* Button hover states */\n.btn-primary {\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #FF4DA6 0%, #FF7BC4 100%) !important;\n  box-shadow: 0 6px 16px rgba(255, 105, 180, 0.4) !important;\n  transform: translateY(-1px);\n}\n\n.btn-primary:active {\n  transform: translateY(0) scale(0.98);\n  box-shadow: 0 2px 8px rgba(255, 105, 180, 0.3) !important;\n}\n\n.btn-primary:active::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  transform: translate(-50%, -50%);\n  animation: ripple 0.6s ease-out;\n}\n\n.btn-secondary {\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-secondary:hover {\n  background-color: var(--bg-tertiary) !important;\n  border-color: var(--accent) !important;\n  transform: translateY(-1px);\n}\n\n.btn-secondary:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.btn-secondary:active::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 105, 180, 0.2);\n  transform: translate(-50%, -50%);\n  animation: ripple 0.6s ease-out;\n}\n\n/* Card hover effect */\n.card-hover {\n  transition: all var(--transition-base);\n  cursor: pointer;\n}\n\n.card-hover:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;\n  transform: translateY(-2px);\n  border-color: rgba(255, 105, 180, 0.3) !important;\n}\n\n.card-hover:active {\n  transform: translateY(0) scale(0.99);\n  transition: transform 100ms ease;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
